@if (keyframes$ | async; as keyframes) {
    <div
        class="img-strip"
        infiniteScroll
        infiniteScrollContainer=".sh-dialog__content"
        fromRoot="true"
        infiniteScrollDistance="2"
        infiniteScrollUpDistance="3"
        alwaysCallback="true"
        [infiniteScrollDisabled]="keyframes.length <= this.MIN_PAGES"
        (scrolled)="onScrollDown()"
        (scrolledUp)="onScrollUp()"
    >
        @for (keyframe of cappedKeyFrames$ | async; track keyframe; let idx = $index) {
            @if (allowTransform) {
                <div
                    class="img-container"
                    [class.-sh-fullscreen]="fullscreen"
                    [ngStyle]="style"
                    (wheel)="scrollZoom($event)"
                    (mousedown)="onDragStart($event)"
                    (mouseup)="onDragEnd($event)"
                    (mouseleave)="onDragEnd($event)"
                    (mousemove)="onDragOver($event)"
                >
                    <img
                        #image
                        class="sh-zoom-image"
                        [class.sh-visually-hidden]="loading"
                        [class.draggable]="draggable && !dragging"
                        [class.dragging]="draggable && dragging"
                        [class.transition]="transition"
                        [class.-sh-fullscreen]="fullscreen"
                        [src]="keyframe"
                        [ngStyle]="style"
                        draggable="false"
                        [alt]="'image-viewer.not-accessible' | translate: { page: idx + pagesLoaded$.value - MIN_PAGES + 1 }"
                        (load)="onLoad(keyframe)"
                        (error)="imageNotFound(keyframe)"
                        (loadstart)="onLoadStart(keyframe)"
                    />
                    @if (loading) {
                        <div class="spinner-container">
                            <svg sh-icon class="-sh-spin" [name]="'spinner'" aria-hidden="true"></svg>
                        </div>
                    }
                </div>
            } @else {
                <div class="img-container">
                    @for (keyframe of keyframes$ | async; track keyframe) {
                        <img
                            #image
                            class="sh-zoom-image"
                            [class.sh-visually-hidden]="loading"
                            [class.draggable]="draggable && !dragging"
                            [class.dragging]="draggable && dragging"
                            [class.transition]="transition"
                            [class.-sh-fullscreen]="fullscreen"
                            [src]="keyframe"
                            [ngStyle]="style"
                            draggable="false"
                            alt="Image not accessible..."
                            (load)="onLoad(keyframe)"
                            (error)="imageNotFound(keyframe)"
                            (loadstart)="onLoadStart(keyframe)"
                        />
                    }
                </div>
            }
            <span>{{ "image-viewer.page" | translate: { page: idx + pagesLoaded$.value - MIN_PAGES + 1, totalPages: keyframes.length } }}</span>
        }

        @if (allowTransform && actionsPosition !== ViewerActionsPosition.BOTTOM_EXTERNAL) {
            <div class="viewer-action-container--vertical">
                @for (item of imageActionButtons; track item) {
                    <button
                        type="button"
                        class="sh-pure-icon-button -sh-raised"
                        [ngClass]="actionsPosition"
                        [title]="item.label"
                        (click)="$any(item).eventListener()"
                    >
                        <svg sh-icon [name]="item.icon" aria-hidden="true"></svg>
                    </button>
                }
            </div>
        }
    </div>

    @if (allowTransform && actionsPosition === ViewerActionsPosition.BOTTOM_EXTERNAL) {
        <div class="viewer-action-container">
            @for (item of imageActionButtons; track item) {
                <button
                    type="button"
                    class="sh-pure-icon-button -sh-raised"
                    [ngClass]="actionsPosition"
                    [title]="item.label"
                    (click)="$any(item).eventListener()"
                >
                    <svg sh-icon [name]="item.icon" aria-hidden="true"></svg>
                </button>
            }
        </div>
    }
}
